import {
  ref, watch, onUnmounted, getCurrentInstance,
} from '@vue/composition-api';
import store from '@/store';

import toast from '@/utils/toast';
import moment from 'moment';
import cashbookStoreModule from '../cashbookStoreModule';

export default function useCashbookList() {
  const STORE_MODULE_NAME = 'cashbook';

  // Register module
  if (!store.hasModule(STORE_MODULE_NAME)) {
    store.registerModule(STORE_MODULE_NAME, cashbookStoreModule);
  }

  // UnRegister on leave
  onUnmounted(() => {
    if (store.hasModule(STORE_MODULE_NAME)) {
      store.unregisterModule(STORE_MODULE_NAME);
    }
  });
  // Use toast
  const toastification = toast();

  const vm = getCurrentInstance().proxy;
  const isHidden = !vm.$can('update', 'cashbook') && !vm.$can('delete', 'cashbook');

  // Table Handlers
  const columns = [
    {
      label: 'Mã',
      field: 'code',
      width: '80px',
    },
    {
      label: 'Thao tác',
      field: 'action',
      tdClass: 'text-center',
      sortable: false,
      width: '100px',
      hidden: isHidden,
    },
    {
      label: 'Tên',
      field: 'name',
    },
    {
      label: 'Loại',
      field: 'type',
    },
    {
      label: 'Số dư đầu kỳ',
      field: 'initialAmount',
      type: 'number',
    },
    {
      label: 'Tồn quỹ',
      field: 'currentAmount',
      type: 'number',
    },
    {
      label: 'Mặc định',
      field: 'default',
      tdClass: 'text-center',
      sortable: false,
      width: '100px',
    },

  ];
  const rows = ref([]);
  const totalAmount = ref(0);
  // filter
  const type = ref(null);
  // current selected rows
  const selectedRows = ref([]);
  const searchTerm = ref('');
  // ssr
  const isLoading = ref(false);
  const totalRecords = ref(0);
  const serverParams = ref({
    searchTerm: '',
    filter: {},
    sort: {},
    page: 1,
    perPage: 20,
  });

  //   handler
  const isHandlerSidebarActive = ref(false);

  //   cashbook
  const blankItem = {
    id: 0,
    type: 'bank',
    name: '',
    bank: null,
    bankName: '',
    bankAddress: '',
    bankAccountHolder: '',
    bankAccountNumber: '',
    initialAmount: 0,
    initialDate: moment(new Date()).toDate(),
  };
  const item = ref(JSON.parse(JSON.stringify(blankItem)));
  const deleteItems = ref([]);
  const resetItem = () => {
    item.value = JSON.parse(JSON.stringify(blankItem));
  };

  //   API Call
  const fetchCashbooks = () => {
    store
      .dispatch('cashbook/fetchCashbooks', serverParams.value)
      .then(response => {
        const { total, items, amount } = response.data;
        totalRecords.value = total;
        rows.value = items;
        totalAmount.value = amount;
      })
      .catch(error => {
        toastification.showToastError(error);
      });
  };

  const deleteCashbooks = cashbooks => {
    store
      .dispatch('cashbook/deleteCashbooks', {
        ids: cashbooks.map(_obj => _obj.id),
      })
      .then(() => {
        fetchCashbooks();
        toastification.showToastDeleteSuccess();
      })
      .catch(error => {
        toastification.showToastError(error);
      });
  };

  const onSubmit = () => {
    store
      .dispatch('cashbook/createCashbook', item.value)
      .then(() => {
        fetchCashbooks();
        isHandlerSidebarActive.value = false;
      });
  };

  const createCashbook = data => {
    store.dispatch('cashbook/createCashbook', data).then(() => {
      fetchCashbooks();
    });
  };

  const updateCashbook = data => {
    store.dispatch('cashbook/updateCashbook', data).then(() => {
      fetchCashbooks();
    });
  };

  const onSelectCashbook = object => {
    item.value = object;
    isHandlerSidebarActive.value = true;
  };

  const onEditItem = val => {
    item.value = val;
  };

  const onDeleteCashbook = val => {
    deleteItems.value = val && val.id > 0 ? [val] : selectedRows.value;
  };

  //   Methods
  const updateParams = newProps => {
    serverParams.value = { ...serverParams.value, ...newProps };
    fetchCashbooks();
  };

  const onPageChange = params => {
    updateParams({ page: params.currentPage });
  };

  const onPerPageChange = params => {
    updateParams({ perPage: params.currentPerPage });
  };

  const onSortChange = params => {
    updateParams({
      sort: {
        type: params[0].type,
        field: params[0].field,
      },
    });
  };

  const onColumnFilter = params => {
    updateParams(params);
  };

  const selectionChanged = params => {
    selectedRows.value = params.selectedRows;
  };

  const setDeleteEnable = () => {
    // Neu co so quy mac dinh thi khong hien thi nut xoa
    if (!selectedRows.value || selectedRows.value.length === 0 || selectedRows.value.filter(_obj => _obj.default).length > 0) {
      return false;
    }

    return true;
  };

  //   Watch
  watch(searchTerm, val => {
    updateParams({ searchTerm: val });
  });
  watch(type, val => {
    const { filter } = serverParams.value;
    if (val) {
      filter.type = val.value;
    } else {
      delete filter.type;
    }
    updateParams({ filter });
  });

  return {
    isHandlerSidebarActive,
    item,
    deleteItems,
    columns,
    rows,
    totalAmount,
    type,
    selectedRows,
    searchTerm,
    isLoading,
    totalRecords,
    serverParams,

    onSubmit,
    onSelectCashbook,
    resetItem,
    onEditItem,
    fetchCashbooks,
    deleteCashbooks,
    createCashbook,
    updateCashbook,
    setDeleteEnable,
    updateParams,
    onPageChange,
    onPerPageChange,
    onSortChange,
    onColumnFilter,
    selectionChanged,
    onDeleteCashbook,
  };
}
